function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCameraEmpty = function SvgCameraEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "10.6667px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      fillOpacity: 1,
      stroke: "none"
    },
    x: 7.161,
    y: 39.415
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 7.161,
    y: 39.415,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "10.6667px",
      fontFamily: "sans-serif",
      InkscapeFontSpecification: "'sans-serif Bold'"
    }
  }, "CAM")), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.087 4.059H8.733c-1.743 0-3.155 1.488-3.155 3.324v13.3c0 1.835 1.412 3.324 3.155 3.324h17.354c1.743 0 3.155-1.489 3.155-3.325v-1.425l5.528 3.329c.238.143.508.219.783.219.871 0 1.577-.745 1.577-1.663V6.923c0-.29-.071-.574-.207-.825-.433-.797-1.396-1.074-2.153-.618l-5.528 3.328V7.383c0-1.836-1.412-3.324-3.155-3.324zm0 6.649v9.974H8.733V7.383h17.354Zm7.888 7.57-4.733-2.85v-2.79l4.733-2.85z",
    style: {
      strokeWidth: 1.76666
    }
  }));
};
export default SvgCameraEmpty;